function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { sites } from '@immediate_media/site-config';
var getDefaultConfig = function getDefaultConfig(_ref) {
  var _sites$siteKey;
  var _ref$siteKey = _ref.siteKey,
    siteKey = _ref$siteKey === void 0 ? 'slate' : _ref$siteKey,
    namespaces = _ref.namespaces,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? 'en' : _ref$fallback;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(siteKey in sites)) {
    // eslint-disable-next-line no-console
    console.error("".concat(siteKey, " is not a recognised site in the translation package. Default to slate"));
  }
  if (!Array.isArray(namespaces)) {
    throw new Error("Namespaces should be an array for example: ['".concat(namespaces, "']"));
  }
  var preferredSiteLanguage = 'en';
  var languages = []; // Set a default language

  if ((_sites$siteKey = sites[siteKey]) !== null && _sites$siteKey !== void 0 && _sites$siteKey.language) {
    var _sites$siteKey2;
    // Ensure only the main language is used: 'pl' not 'pl-PL'
    preferredSiteLanguage = (_sites$siteKey2 = sites[siteKey]) === null || _sites$siteKey2 === void 0 ? void 0 : _sites$siteKey2.language.split('-')[0];
  }
  languages.push(preferredSiteLanguage);
  if (preferredSiteLanguage !== fallback) {
    languages.push(fallback);
  }
  return _objectSpread(_objectSpread({}, options), {}, {
    lng: preferredSiteLanguage,
    ns: namespaces,
    // namespaces to load. DefaultNS is the first in the array
    fallbackNS: namespaces.slice(1),
    // Fallback to any other namespaces
    fallbackLng: fallback,
    supportedLngs: languages,
    load: 'languageOnly' // only 'en' not 'en-US'
  });
};
export default getDefaultConfig;